import React, { Component } from 'react';
import { Link } from 'react-router';
import Usermenu from './usermenu.jsx'

class Sidebar extends Component {
  constructor(props){
    super(props);
    this.checkWorkspaceOwner = this.checkWorkspaceOwner.bind(this);
  }

  checkWorkspaceOwner(){
    const appData = JSON.parse(localStorage.getItem('appData')) || {};
    if(appData.user && appData.user.phone_number){

      let userPhone = (appData.user.phone_number).trim();
      
      const currentWs = this.props.workspace || {};
      let ownerPhone = undefined;
      if(currentWs.owner) ownerPhone = currentWs.owner.phone_number
        
        if(userPhone !== ownerPhone) return false;
        else return true;
    }
    else return false;
  }

  render() {
    return (
      <div className="sidebar">

        <div className="sidebar-wrapper">
          <div className="logo">
                هنگام
          </div>

          <ul className="nav">

            <li>
                <Link to= "/app">
                    <p>زمانسنج</p>
                </Link>
            </li>
              {(this.checkWorkspaceOwner())?(
                <li disabled={this.checkWorkspaceOwner()} >
                    <Link to= "/app/project">
                        <p>پروژه </p>
                    </Link>
                </li>
              ):(null) }
            
            <li>
              <Link to= "/app/report">
                  <p>گزارش </p>
              </Link>
            </li>

            <li>
              <Link to= "/app/workspace">
                  <p>محیط‌های کار</p>
              </Link>
            </li>
          </ul>
          {(this.props.socketStatus)?(null):(
          <div className="socket-err">
           قطع ارتباط با سرور
          </div>
          )}
          <div className="user-sidebar-item">
            <Usermenu />
          </div>
        </div>
      </div>
    );
  }
}

export default Sidebar;
